function function_reg_str_to_arr(str) {
	if (!str) {
		return [];
	}

	// ${} 正则
	let reg = /\$\{(.+?)\}/ // ["${xxx}", "xxx"] 匹配第一个  
	let reg_g = /\$\{(.+?)\}/g // ["${xxx1}", "${xxx2}"] 匹配所有该规则的

	// <Warning/> 正则
	let reg_wraning = /\$\{(.+?)\}/
	let reg_wraning_g = /<Warning[^>]*>/g

	// <Text_R/><Text_R> 正则
	let reg_r = /<Text_R[^>]*>(.+?)<\/Text_R>/
	let reg_r_g = /<Text_R[^>]*>(.+?)<\/Text_R>/g

	// <Text_Com_R/><Text_Com_R> 正则
	let reg_com_r = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/
	let reg_com_r_g = /<Text_Com_R[^>]*>(.+?)<\/Text_Com_R>/g
	
	// <Text_Com_R/><Text_Com_R> 正则
	let reg_com_b = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/
	let reg_com_b_g = /<Text_Com_B[^>]*>(.+?)<\/Text_Com_B>/g

	// <Text_G/><Text_G> 正则
	let reg_green = /<Text_G[^>]*>(.+?)<\/Text_G>/
	let reg_green_g = /<Text_G[^>]*>(.+?)<\/Text_G>/g

	// <Tab_Warning_Text_R/><Tab_Warning_Text_R> 正则
	let reg_t_r = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/
	let reg_t_r_g = /<Tab_Warning_Text_R[^>]*>(.+?)<\/Tab_Warning_Text_R>/g

	// <Tab_Text_P/><Tab_Text_P> 正则
	let reg_t_p = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/
	let reg_t_p_g = /<Tab_Text_P[^>]*>(.+?)<\/Tab_Text_P>/g

	let showTextArr = [];

	// <Warning/>
	showTextArr = reg_deal_single_tab([str], '<Warning/>');

	// <Text_R/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_r, reg_r_g)

	// <Text_Com_R/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_com_r, reg_com_r_g)

	// <Text_Com_B/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_com_b, reg_com_b_g)

	// <Text_G/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_green, reg_green_g)

	// <Tab_Warning_Text_R/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_t_r, reg_t_r_g)

	// <Tab_Text_P/>
	showTextArr = reg_deal_double_tab(showTextArr, reg_t_p, reg_t_p_g)

  // console.log(showTextArr)
	return showTextArr;
}

function reg_deal_single_tab(target_arr, reg) {
	if (!target_arr) {
		return [];
	}
	if (!reg) {
		return JSON.parse(JSON.stringify(target_arr));
	}
	let str_arr = JSON.parse(JSON.stringify(target_arr));
	let result = [];
	for (let i = 0; i < str_arr.length; i++) {
		let item = str_arr[i];
		if (item.indexOf(reg) == -1) {
			result.push(item);
		} else {
			let temp_item = item;
			let temp_warning_arr = temp_item.split(reg) || [];
			for (let i = 0; i < temp_warning_arr.length; i++) {
				let item = temp_warning_arr[i];
				if (item == '' && i == 0) {
					result.push(reg);
				} else {
					result.push(item);
					if (i < temp_warning_arr.length - 1) {
						result.push(reg);
					}
				}
			}
		}
	}
	return result || [];
}

function reg_deal_double_tab(target_arr, reg, reg_g) {
	if (!target_arr) {
		return [];
	}
	if (!reg) {
		return JSON.parse(JSON.stringify(target_arr));
	}
	let temp_arr = JSON.parse(JSON.stringify(target_arr));
	let result = [];
	for (let i = 0; i < temp_arr.length; i++) {
		let item = temp_arr[i] || '';
		if (!item.match(reg)) { // 不包含
			result.push(item);
		} else { // 包含
			let str = item;
			let special_r_arr = str.match(reg_g);
			let arr = [];
			for (let j = 0; j < special_r_arr.length; j++) {
				let special_r_arr_item = special_r_arr[j];
				let index = str.indexOf(special_r_arr_item);
				arr.push(str.slice(0, index));
				arr.push(str.slice(index, special_r_arr_item.length + index));
				str = str.slice(special_r_arr_item.length + index, str.length);
			}
			if (str != '' && str.length > 0 && str) {
				arr.push(str);
			}
			for (let j = 0; j < arr.length; j++) {
				let tempItem = arr[j];
				result.push(tempItem);
			}
		}
	}
	return result || [];
}
function nmn(){
  console.log(32423)
}
export default {
  function_reg_str_to_arr
  // nmn
}